<template>
  <footer class="results-footer">
    <span class="emblem"
      ><img
        src="https://ccassets.fra1.cdn.digitaloceanspaces.com/cc-emblem-grey.svg"
        alt="Cogniclick"
    /></span>
    <span
      >Powered by
      <a target="_blank" href="https://www.cogniclick.com"
        >CogniClick.com</a
      ></span
    >
  </footer>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
footer {
  padding: 1.5rem 0;
  text-align: center;
  span {
    vertical-align: middle;
    color: #929291 !important;
  }
  span.emblem {
    img {
      width: 20px;
    }
  }
  a:link,
  a:visited {
    color: #7d7d7b !important;
    font-weight: bold;
    text-decoration: none;
  }
  @media (min-width: 768px) {
    padding: 2.5rem 0;
  }
}
</style>
